import { render } from "./Hotspot31.vue?vue&type=template&id=6b5ae5ee&scoped=true&ts=true"
import script from "./Hotspot31.vue?vue&type=script&lang=ts"
export * from "./Hotspot31.vue?vue&type=script&lang=ts"

import "./Hotspot31.vue?vue&type=style&index=0&id=6b5ae5ee&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5ae5ee"]])

export default __exports__